module.exports = __webpack_public_path__ + "img/shopping_905017_r3@2x.7d9c9a88.png";